import { InfoWindow, Marker } from '@react-google-maps/api';
import React from 'react';
// @ts-ignore
import { useHistory } from 'react-router-dom';

interface MarkerWindowProps {
    item: any,
    open: boolean,
    onOpen: () => void,
    onClose: () => void,
}

export default function MarkerWindow({ item, open, onOpen, onClose, ...props }: MarkerWindowProps) {
    const markerRef = React.useRef(null)
    const history = useHistory();
    return <>
        <Marker
            icon={item.img} position={item.pos}
            onClick={() => {
                onOpen()
                console.log(item)
            }}
            ref={markerRef}
        />
        {open ? <InfoWindow
            onCloseClick={onClose}
            //@ts-ignore
            anchor={markerRef?.current}
            position={item.pos}
            options={{
                pixelOffset: new google.maps.Size(0, -40),
            }}
        >
            <div>
                <a href={`156#/ocorrencias/ver/${item.info.ocorrencia_id}`} onClick={(e) => {
                    e.preventDefault()
                    history.push(`/ocorrencias/ver/${item.info.ocorrencia_id}`)
                }}><h3>{item.info.protocolo}</h3></a>
                <p>{item.info.servico}</p>
            </div>
        </InfoWindow> : null}
    </>
}